import { Injectable } from "@angular/core";
import { C_GameGroupByName, C_Result } from "@sports-models/index";
import { SportHandleList, SportsConstants } from "@sports-utils/index";

@Injectable({ providedIn: "root" })
export class GoalScorerUtils {
  public getMarketGoalScorer(
    groupedMarkets: C_GameGroupByName[],
    actualMarket: C_GameGroupByName,
    skipCall = false,
  ): C_GameGroupByName[] {
    if (actualMarket.SportHandle !== SportHandleList.soccer || skipCall) {
      return groupedMarkets;
    }
    const listOfIdsGoalMarkets = [
      SportsConstants.GameTypesDefinitions.FirstGoalscorer.Id,
      SportsConstants.GameTypesDefinitions.ScoreGoalDuringTheMatch.Id,
      SportsConstants.GameTypesDefinitions.ScoreTwoOrMoreGoals.Id,
    ];
    const listOfMarketsAvailable = [];
    let listOfScorerMarkets: any = [];
    listOfIdsGoalMarkets.forEach((idMarket) => {
      const scorerMarket = groupedMarkets.find((market) => market.GameType === idMarket);
      if (scorerMarket) {
        //this.getGoalScorersOrder(idMarket, scorerMarket);
        scorerMarket.position = idMarket;
        listOfScorerMarkets.push(scorerMarket);
        listOfMarketsAvailable.push(idMarket);
      } else {
        const aux = C_GameGroupByName.parse({ GameType: idMarket });
        aux.position = idMarket;
        listOfScorerMarkets.push(aux);
      }
    });

    if (!listOfMarketsAvailable.length) {
      return groupedMarkets;
    }
    const numberOfGoalMarketsNeeded = listOfIdsGoalMarkets.length;
    if (listOfMarketsAvailable.length < numberOfGoalMarketsNeeded) {
      listOfScorerMarkets = this.getMissingScoreMarkets(listOfScorerMarkets);
    }

    groupedMarkets = this.deleteMarketsUseless(groupedMarkets, listOfIdsGoalMarkets);

    const newMarketScore: C_GameGroupByName = this.getGoalScoreMarket(listOfScorerMarkets, actualMarket);
    this.getNewScoreMarket(groupedMarkets, newMarketScore);

    return groupedMarkets;
  }

  private getMissingScoreMarkets(listOfScorerMarkets: C_GameGroupByName[]) {
    const ghostMarket = C_GameGroupByName.parse({
      Name: SportsConstants.GoalscorersLiteral,
      GroupResults: [],
    });
    const newMarket: any = [];

    listOfScorerMarkets.map((market) => {
      if (!market) {
        newMarket.push(ghostMarket);
      } else {
        newMarket.push(market);
      }
    });
    return newMarket;
  }

  private deleteMarketsUseless(
    groupedMarkets: C_GameGroupByName[],
    listOfIdsGoalMarkets: number[],
  ): C_GameGroupByName[] {
    const listOfNoScorerMarkets: C_GameGroupByName[] = [];
    groupedMarkets.forEach((market) => {
      if (
        market.GameType !== listOfIdsGoalMarkets[0] &&
        market.GameType !== listOfIdsGoalMarkets[1] &&
        market.GameType !== listOfIdsGoalMarkets[2]
      ) {
        listOfNoScorerMarkets.push(market);
      }
    });
    return listOfNoScorerMarkets;
  }

  private getNewScoreMarket(groupedMarkets: C_GameGroupByName[], newMarketScore: C_GameGroupByName) {
    let positionHatTrickMarket;
    groupedMarkets.forEach((market, index) => {
      if (market.GameType === SportsConstants.GameTypesDefinitions.HatTrick.Id) {
        positionHatTrickMarket = index;
      }
    });
    if (positionHatTrickMarket) {
      groupedMarkets.splice(positionHatTrickMarket, 0, newMarketScore);
    } else {
      groupedMarkets.push(newMarketScore);
    }
  }

  /**
   * Creamos una lista de goleadores y limpiamos la lista de valores repetidos, asignamos los resultados a la lista de goleadores, construimos el mercado en su totalidad y lo devolvemos
   * @param listOfScorerMarkets
   * @param actualMarket
   * @returns C_GameGroupByName
   */
  private getGoalScoreMarket(listOfScorerMarkets: any[], actualMarket: any): C_GameGroupByName {
    const listOfPlayerNames = this.getListOfPlayers(listOfScorerMarkets);
    const ListOfPlayersWithResults = this.getGoalScorersData(listOfPlayerNames, listOfScorerMarkets);
    const { categoryInfoScoreMarket, groupResults } = this.getCategoryAndGroupResults(listOfScorerMarkets);
    return this.prepareGoalScoreMarket(
      ListOfPlayersWithResults,
      actualMarket,
      categoryInfoScoreMarket,
      groupResults,
    );
  }

  /* buscamos todos los nombres de los jugadores en los tres mercados,
   * quitamos lo valores repetidos y devolvemos la lista */
  private getListOfPlayers(listOfScorerMarkets: any[]) {
    const ListOfPlayersInMarkets: any = [];
    listOfScorerMarkets.forEach((game) => {
      game.GroupResults.forEach((result: any) => {
        ListOfPlayersInMarkets.push(result.Name);
      });
    });

    const listOfPlayerNames = Array.from(new Set(ListOfPlayersInMarkets));
    return listOfPlayerNames;
  }
  /*recorremos la lista de jugadores y la cruzamos con la lista de mercados y extraemos los resultados cuando coincidan con el nombre del jugador,
   * construimos el objeto que vamos autilizar en la vista y lo añadimos a la lista que vamos a devolver con los datos del mercado,
   * devolvemos el la lista con los jugadores y sus resultados asociados */
  /* si el resultado no ha sido encontrado declaramos uno vacio y le asignamos la posicion en funcion del gameType*/
  private getGoalScorersData(listOfPlayerNames: any[], listOfScorerMarkets: any[]) {
    const listOfPlayersWithResults: any = [];
    listOfPlayerNames.forEach((player: string) => {
      const resultsListByPlayerName: any = [];
      listOfScorerMarkets.forEach((market) => {
        const gameType = market.GameType;
        const resultByPlayerName = market.GroupResults.filter((result: any) => result.Name === player);
        if (!resultByPlayerName.length) {
          resultsListByPlayerName.push(this.getMissingResultInGoalScorers(gameType));
          return;
        }
        resultsListByPlayerName.push(resultByPlayerName[0]);
      });

      const newPlayerWithResultsList = {
        spov: player,
        results: resultsListByPlayerName,
      };
      newPlayerWithResultsList.results = this.getOrderResultsInGoalScorers(newPlayerWithResultsList);
      listOfPlayersWithResults.push(newPlayerWithResultsList);
    });

    return listOfPlayersWithResults;
  }

  private getCategoryAndGroupResults(listOfScorerMarkets: any[]) {
    const groupResults = [
      ...listOfScorerMarkets[0].GroupResults,
      ...listOfScorerMarkets[1].GroupResults,
      ...listOfScorerMarkets[2].GroupResults,
    ];
    const categoryInfoScoreMarket = {
      CategoryInfos: listOfScorerMarkets[0].CategoryInfos,
      CategoryInfo: listOfScorerMarkets[0].CategoryInfo,
    };
    return { categoryInfoScoreMarket, groupResults };
  }

  private prepareGoalScoreMarket(
    playerWithResultsList: any[],
    actualMarket: any,
    categoryInfoScoreMarket: any,
    groupResults: any[],
  ): C_GameGroupByName {
    return C_GameGroupByName.parse({
      Name: SportsConstants.GoalscorersLiteral,
      nameLeague: actualMarket.LeagueName,
      Priority: actualMarket.Priority,
      CategoryInfos: categoryInfoScoreMarket.CategoryInfos,
      CategoryInfo: categoryInfoScoreMarket.CategoryInfo,
      DisplayTypeName: "3buttonlist",
      teamAway: SportsConstants.GameTypesDefinitions.ScoreTwoOrMoreGoals.Literal,
      teamHome: "Primer",
      titleCenter: "Durante",
      isSoftCombined: true,
      isHardCombined: false,
      isSpecialMarket: false,
      isCombined: true,
      headerClass: "sb-grid-header--single",
      displayMode: "single",
      GroupResults: groupResults,
      combinedResults: playerWithResultsList,
    });
  }

  /* devolvemos el resultado ausente y le asignamos una posicion en funcion del id */
  private getMissingResultInGoalScorers(gameType: any): any {
    return {
      ...this.NewResultMissing(),
      ...{ position: this.getResultPositionInGoalScorer(gameType) },
    };
  }

  private getOrderResultsInGoalScorers(newPlayerWithResultsList: { spov: string; results: any[] }): any[] {
    /* ordered the results*/
    return newPlayerWithResultsList.results.sort((a, b) => a.position - b.position);
  }

  private NewResultMissing(): C_Result {
    return new C_Result("-", null, null, null, null, null, null, null, null, null, null, null);
  }

  /*asignamos una posicion al mercado ausente*/
  private getResultPositionInGoalScorer(gameType): number {
    if (gameType === SportsConstants.GameTypesDefinitions.FirstGoalscorer.Id) {
      return 0;
      // eslint-disable-next-line no-dupe-else-if
    } else if (gameType === SportsConstants.GameTypesDefinitions.ScoreGoalDuringTheMatch.Id) {
      return 1;
    }
    return 2;
  }

  public checkGoleadoresCatOrder(categoryId, marketBets) {
    let newMarketBets = [...marketBets];
    if (categoryId === SportsConstants.goleadoresCat) {
      newMarketBets.sort((a, b) => a[SportsConstants.priorityForCat] - b[SportsConstants.priorityForCat]);
      const goalscorers = newMarketBets.find((elem) => elem.Name === SportsConstants.GoalscorersLiteral);
      const hatTrick = newMarketBets.find(
        (elem) => elem.Name === SportsConstants.GameTypesDefinitions.HatTrick.Literal,
      );
      const lastGoalscorer = newMarketBets.find(
        (elem) => elem.Name === SportsConstants.GameTypesDefinitions.LastGoalscorer.Literal,
      );
      newMarketBets = newMarketBets.filter(
        (elem) =>
          ![
            SportsConstants.GoalscorersLiteral,
            SportsConstants.GameTypesDefinitions.LastGoalscorer.Literal,
            SportsConstants.GameTypesDefinitions.HatTrick.Literal,
          ].includes(elem.Name),
      );
      if (lastGoalscorer) {
        newMarketBets.unshift(lastGoalscorer);
      }
      if (hatTrick) {
        newMarketBets.unshift(hatTrick);
      }
      if (goalscorers) {
        newMarketBets.unshift(goalscorers);
      }
    }
    return newMarketBets;
  }
}
